import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { installKioskKeyboardListeners } from './utils/kioskMode';

// The redesign is deliberately isolated to Shadow hosts. Keeping the marker
// on <html> prevents a future non-Shadow build from inheriting preview styles
// merely because both surfaces share this source tree.
if (window.location.hostname.startsWith('shadow.')) {
  document.documentElement.classList.add('intrlock-shadow');
}

// Panel-mode listener — when the page is served with ?kiosk=1 it pokes the
// local Intrlock Panel server to show/hide the on-screen keyboard on text
// input focus. No-op in regular browsers.
installKioskKeyboardListeners();

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
